import CONSTS from '../beans/SERVICE_TYPES'
import { MiscUtil, mergeConfig, deepCopy } from '../../miscUtil'

/**
 * 创建服务
 * @param {*} type
 * @param  {...any} rest
 */
export default async (type, ...rest) => {
    switch (type.toUpperCase()) {
        case 'WMS':
            return createWMSService(...rest)
        case 'WMTS':
            return createWMTSService(...rest)
        case 'VTS':
            return createVTSService(...rest)
        case 'TILE':
            return createTILEService(...rest)
        case 'TERRAIN':
            return createTERRAINService(...rest)
        case 'MODELCESIUM':
            return createMODELCESIUMService(...rest)
        case 'WTFS':
            return createWTFSService(...rest)
        case 'WFS':
            return createWFSService(...rest)
        default:
            throw '暂不支持的服务类型'
    }
}

// 创建wms服务
async function createWMSService(config, minZoom, maxZoom) {
    let {
        type,
        name,
        url,
        version,
        format,
        epsg,
        visibility,
        opacity,
        maxExtent,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.WMS)

    let extentArray = maxExtent.split(',')
    let rectangle = Cesium.Rectangle.fromDegrees(
        extentArray[0],
        extentArray[1],
        extentArray[2],
        extentArray[3]
    )

    //创建Cesium的wmsProvider
    let wmsProvider = new Cesium.WebMapServiceImageryProvider({
        url: new Cesium.Resource({
            proxy: new Cesium.DefaultProxy(MiscUtil.getProxyUrl()), //设置代理地址
            url: url
        }),
        layers: name,
        parameters: {
            format: 'image/png',
            transparent: true
        },
        rectangle: rectangle
    })

    //样式
    let layerOption = {
        alpha: opacity,
        show: visibility
    }

    let wmsLayer = new Cesium.ImageryLayer(wmsProvider, layerOption)

    return { type, data: { layer: wmsLayer } }
}

// 创建wmts服务
async function createWMTSService(config, minZoom, maxZoom) {
    let {
        type,
        name,
        url,
        version,
        style,
        zoomOffset,
        matrixSet,
        matrixIds,
        format,
        visibility,
        opacity,
        maxExtent,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.WMTS)

    let extentArray = maxExtent.split(',')
    let rectangle = Cesium.Rectangle.fromDegrees(
        extentArray[0],
        extentArray[1],
        extentArray[2],
        extentArray[3]
    )

    //创建Cesium的wmtsProvider
    let wmtsProvider = new Cesium.WebMapTileServiceImageryProvider({
        url: new Cesium.Resource({
            proxy: new Cesium.DefaultProxy(MiscUtil.getProxyUrl()), //设置代理地址
            url: url
        }),
        layer: name,
        style: style,
        format: format,
        tileMatrixSetID: matrixSet,
        tilingScheme: new Cesium.GeographicTilingScheme(),
        tileMatrixLabels: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20'
        ],
        rectangle: rectangle,
        maximumLevel: maxZoom - 1
    })

    //样式
    let layerOption = {
        alpha: opacity,
        show: visibility
    }

    let wmtsLayer = new Cesium.ImageryLayer(wmtsProvider, layerOption)

    return { type, data: { layer: wmtsLayer } }
}

// 创建矢量切片
async function createVTSService(config, minZoom, maxZoom) {
    const {
        type,
        name,
        url,
        version,
        styles,
        style,
        zoomOffset,
        matrixSet,
        matrixIds,
        format,
        formats,
        visibility,
        opacity,
        maxExtent
    } = mergeConfig(deepCopy(config), CONSTS.VTS)

    //矢量瓦片
    let mvtProvider = new Cesium.MVTProvider({
        proxy: new Cesium.DefaultProxy(MiscUtil.getProxyUrl()),
        ol: ol,
        url: 'http://192.168.100.231:8889/xz_mkt/wmts',
        layer: 'XZMKT_SQLITE',
        tileMatrixSetID: 'XZMKT_SQLITE_Matrix_0',
        styleName: 'style_vts.xzmkt_sqlite',
        maximumLevel: 17
    })

    //样式
    let layerOption = {
        alpha: opacity,
        show: visibility
    }

    let mvtLayer = new Cesium.ImageryLayer(mvtProvider, layerOption)

    return { type, data: { layer: mvtLayer } }
}

// 创建TILE图层
async function createTILEService(config, minZoom, maxZoom) {
    const {
        type,
        name,
        url,
        version,
        format,
        formats,
        visibility,
        opacity,
        maxExtent,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.TILE)

    let reqUrl =
        url.split('/services/tile')[0] + '/DataServer?T=tile&x={x}&y={y}&l={z}'
    let extentArray = maxExtent.split(',')
    let rectangle = Cesium.Rectangle.fromDegrees(
        extentArray[0],
        extentArray[1],
        extentArray[2],
        extentArray[3]
    )
    //创建Cesium的tileProvider
    let tileProvider = new Cesium.UrlTemplateImageryProvider({
        url: new Cesium.Resource({
            proxy: new Cesium.DefaultProxy(MiscUtil.getProxyUrl()), //设置代理地址
            url: reqUrl
        }),
        tilingScheme: new Cesium.GeographicTilingScheme(),
        maximumLevel: maxZoom,
        rectangle: rectangle,
        customTags: {
            z: function(imageryProvider, x, y, level) {
                return level + 1
            }
        }
    })

    //样式
    let layerOption = {
        alpha: opacity,
        show: visibility
    }

    let tileLayer = new Cesium.ImageryLayer(tileProvider, layerOption)

    return { type, data: { layer: tileLayer } }
}

// 创建TERRAIN图层
async function createTERRAINService(config, minZoom, maxZoom) {
    let {
        type,
        name,
        url,
        version,
        format,
        formats,
        visibility,
        opacity,
        maxExtent,
        dataType,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.TERRAIN)

    let requireUrl = ''
    if (visibility) {
        requireUrl = url.split('/services/tile')[0] + '/DataServer'
    }
    let demType = Cesium.GeoTerrainProvider.FLOAT
    if (dataType.toUpperCase().indexOf('INT') > -1) {
        demType = Cesium.GeoTerrainProvider.INT
    }

    let terrainProvider = new Cesium.GeoTerrainProvider({
        dataType: demType,
        urls: [requireUrl],
        name: name,
        maxExtent: maxExtent,
        opacity: opacity,
        topLevel: minZoom,
        bottomLevel: maxZoom,
        proxy: new Cesium.DefaultProxy(MiscUtil.getProxyUrl())
    })

    return { type, data: { layer: terrainProvider } }
}

// 创建MODEL_CESIUM图层
async function createMODELCESIUMService(config, minZoom, maxZoom) {
    const { type, name, url, version, visibility, opacity } = mergeConfig(
        deepCopy(config),
        CONSTS.MODELCESIUM
    )

    //创建Cesium的wmts图层
    let modelLayer = new Cesium.Cesium3DTileset({
        url: url,
        show: visibility
    })

    return { type, data: { layer: modelLayer } }
}

// 创建WTFS图层
async function createWTFSService(config, minZoom, maxZoom) {
    const { type, name, url, maxExtent } = mergeConfig(
        deepCopy(config),
        CONSTS.TILE
    )

    let extentArr = maxExtent.split(',')

    let wtfsOPtion = {
        proxy: new Cesium.DefaultProxy(MiscUtil.getProxyUrl()), //设置代理地址
        //viewer: this.mapView.map3d,
        //三维地名，使用wtfs服务
        url: url,
        metadata: {
            boundBox: {
                minX: extentArr[0],
                minY: extentArr[1],
                maxX: extentArr[2],
                maxY: extentArr[3]
            },
            minLevel: minZoom,
            maxLevel: maxZoom
        },
        aotuCollide: true, //是否开启避让
        collisionPadding: [0, 5, 3, 0], //开启避让时，标注碰撞增加内边距，上、右、下、左
        serverFirstStyle: true, //服务端样式优先
        labelGraphics: {
            //解决字体模糊的问题：1、先放大后缩小
            font: '28px sans-serif',
            bold: false,
            scale: 1,
            fillColor: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 2,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            showBackground: false,
            backgroundColor: Cesium.Color.RED,
            backgroundPadding: new Cesium.Cartesian2(10, 10),
            horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
            verticalOrigin: Cesium.VerticalOrigin.TOP,
            eyeOffset: Cesium.Cartesian3.ZERO,
            pixelOffset: new Cesium.Cartesian2(5, 5),
            disableDepthTestDistance: undefined
        },
        billboardGraphics: {
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.CENTER,
            eyeOffset: Cesium.Cartesian3.ZERO,
            pixelOffset: Cesium.Cartesian2.ZERO,
            alignedAxis: Cesium.Cartesian3.ZERO,
            color: Cesium.Color.WHITE,
            rotation: 0,
            scale: 1,
            width: 18,
            height: 18,
            disableDepthTestDistance: undefined
        }
    }

    return { type, data: { layer: wtfsOPtion } }
}

// 创建WFS服务
function createWFSService(config, minZoom, maxZoom) {
    return { type: 'WFS', data: null }
}
